import * as Yup from "yup";
import Search from "../../domain/entities/Search";
import LocationDetails from "../../domain/entities/LocationDetails";


export interface SearchLocationFormValues {
    search: Search[];
    detailsPlace: LocationDetails[];
}

export const searchLocationValidationSchema = Yup.object({
    search: Yup.array().of(
        Yup.object({
            place_id: Yup.string(),
            description: Yup.string(),
        })
    ).required("Search is required"),
    detailsPlace: Yup.array().of(
        Yup.object({
            formattedAddress: Yup.string(),
            location: Yup.object({
                lat: Yup.number(),
                lng: Yup.number(),
            }),
        })
    ),
});